import moment from 'moment'
import { TweenMax, Power3 } from 'gsap'
import { bus } from '@/consts'
import SvgLib from '@/components/SvgLib'

export default {
  name: 'Countdown',
  template: '#countdown-template',
  data () {
    return {
      todaysDate: moment().startOf('day'),
      tournaments: [
        // {
        //   date: '05-25-2018',
        //   name: 'demacia'
        // },
        // {
        //   date: '06-08-2018',
        //   name: 'demacia'
        // },
        // {
        //   date: '06-22-2018',
        //   name: 'shadowisles'
        // },
        // {
        //   date: '07-06-2018',
        //   name: 'shadowisles'
        // },
        // {
        //   date: '08-10-2018',
        //   name: 'piltover'
        // },
        // {
        //   date: '08-24-2018',
        //   name: 'piltover'
        // },
        // {
        //   date: '09-07-2018',
        //   name: 'frelijord'
        // },
        // {
        //   date: '09-21-2018',
        //   name: 'frelijord'
        // },
        // {
        //   date: '10-05-2018',
        //   name: 'zaun'
        // },
        // {
        //   date: '10-19-2018',
        //   name: 'zaun'
        // }
      ],
      daysNum: 0,
      tournamentName: ''
    }
  },
  components: { SvgLib },
  methods: {
    getDaysRemaining (dateStr) {
      let dateObj = moment(dateStr, 'MM-DD-YYYY').startOf('day')
      return dateObj.diff(this.todaysDate, 'days')
    },
    setTournamentData () {
      // return the number of days remaining for the first future date in the array
      let i
      for (i = 0; i < this.tournaments.length; i++) {
        let daysRemaining = this.getDaysRemaining(this.tournaments[i].date)
        if (daysRemaining <= 0 && daysRemaining >= -2) { // show 0 days remaining during the entire Clash weekend, Starting Friday morning and ending Sunday night
          this.tournamentName = this.tournaments[i].name
          this.daysNum = 0
          break
        } else if (daysRemaining > 0) { // beginning on the following Monday, start showing the days remaining until the next tournament
          this.tournamentName = this.tournaments[i].name
          this.daysNum = daysRemaining
          break
        }
      }
    }
  },
  mounted () {
    this.setTournamentData()
    if (this.tournaments.length > 0) {
      this.$nextTick(() => {
        bus.$on('loadAnimation', () => {
          TweenMax.fromTo(this.$refs.img, 2, {opacity: 0}, {opacity: 1, ease: Power3.easeInOut})
          TweenMax.fromTo(this.$refs.num, 2, {opacity: 0, x: 15}, {opacity: 1, x: 0, ease: Power3.easeInOut})
          TweenMax.fromTo(this.$refs.days, 1.5, {opacity: 0, x: 15}, {opacity: 1, x: 0, ease: Power3.easeInOut})
          TweenMax.fromTo(this.$refs.cup, 1.5, {opacity: 0, x: 15}, {
            opacity: 1,
            x: 0,
            ease: Power3.easeInOut,
            delay: '0.2'
          })
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Countdown.js